



















// @ts-ignore
import v8n from 'v8n';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { authModule, snackModule } from '@/store';
import { ApiError } from '@/api';

@Component
export default class extends Vue {
  email: string = '';
  password: string = '';

  loading: boolean = false;
  valid: boolean = false;
  error: string = '';
  success: string = '';

  emailRules = [
    (v: string) =>
      v8n()
        .string()
        .not.empty()
        .test(v) || 'Email address required',

    (v: string) =>
      v8n()
        .pattern(/\S+@\S+\.\S+/)
        .test(v) || 'Email address must be valid',
  ];

  passwordRules = [
    (v: string) =>
      v8n()
        .string()
        .not.empty()
        .test(v) || 'Password required',
  ];

  clear() {
    this.error = '';
    // @ts-ignore
    this.$refs.loginForm.reset();
  }

  async login() {
    this.loading = true;
    try {
      await authModule.login({ email: this.email, password: this.password });
      authModule.closeLoginDialog(true);
      snackModule.showSnackbar('Login Successful');
      this.error = '';
      this.success = '';
      // Emitted, not acted on here: this form is shared by the login *page* and
      // the popup, and only the page redirects a user with something
      // outstanding to their notices. The popup opens over whatever the user
      // was doing - often an auction they are about to bid on - so navigating
      // away from it would take them off the page they came to use.
      this.$emit('login-success');
    } catch (e) {
      this.error = e.response ? e.response.errors[0].detail : 'Unknown error';
    } finally {
      this.loading = false;
    }
  }

  forgotPassword() {
    this.$router.push({ name: 'forgot-password' });
    authModule.closeLoginDialog(false);
  }
}
